import { render, staticRenderFns } from "./MagicLinkJoinCircle.vue?vue&type=template&id=d28c95b0&scoped=true"
import script from "./MagicLinkJoinCircle.vue?vue&type=script&lang=js"
export * from "./MagicLinkJoinCircle.vue?vue&type=script&lang=js"
import style0 from "./MagicLinkJoinCircle.vue?vue&type=style&index=0&id=d28c95b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28c95b0",
  null
  
)

export default component.exports